export default "__VITE_ASSET__Bkxh5MLf__"